<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
        <div class="trezo-card-title">
            <h5 class="!mb-0">
                Pie Monochrome Chart
            </h5>
        </div>
    </div>
    <div class="trezo-card-content">
        <div id="pie_monochrome_chart"></div>
    </div>
</div>